module.exports = __webpack_public_path__ + "img/nav-leave.9ef6b15f.svg";